<script setup>
import { ref, watch } from 'vue'
import { userService } from '@/http'
import store from '@/store'
import { useRoute } from 'vue-router'

import ThumbCover from '@/Components/ThumbCover.vue'
import Link from '../Components/Link.vue'

const route = useRoute()

const items = ref([])
const page = ref(1)
const total = ref(0)


const fetchData = () => {
  if(page.value < 1) {
    page.value = 1
  }
  let filter = {
    page: page.value,
    ...route.query,
    ...route.params
  }

  filter.limit = store.isDatingView ? 1 : 9

  userService.index(filter).then(res => {
    total.value = res.data.total

    if(page.value > 1 && !store.isDatingView) {
      items.value = [...items.value, ...res.data.items]
      return
    }

    items.value = res.data.items
    
    // items.value = res.data.items.map(item => {
    //   return {
    //     ...item,
    //     style: {
    //       transform: '',
    //       opacity: 1
    //     },
    //     showBadge: false,
    //   }
    // })
  })
}

const loadMore = () => {
  page.value++
  fetchData()
}

const changePage = (value) => {
  page.value = page.value + (value ? 1 : -1)
  store.cards.page = page.value
  console.log(page.value, store.cards.page);
  fetchData()
}

const changeView = (value) => {
  store.changeView(value)
  items.value = []
  page.value = store.isDatingView ? store.cards.page : 1
  fetchData()
}

let startX, currentCard;

const onTouchStart = (e, index) => {
  return;
  //startDrag(e, currentCard);
  currentCard = index;
  console.log(1111, e, index);
  startX = e.type.includes('mouse') ? e.clientX : e.touches[0].clientX;
}

const onTouchMove = (e, index) => {
  return;
  //onDrag(e);
  const currentX = e.type.includes('mouse') ? e.clientX : e.touches[0].clientX;
  const deltaX = currentX - startX;
  const rotation = deltaX / 10;

  items.value[currentCard].style.transform =`translateX(${deltaX}px) rotate(${rotation}deg)`;;
  console.log(2222);
}

const onTouchEnd = (e) => {
  return;
  //endDrag(e);
  console.log(3333);
}


watch(
  () => route.query,
  async () => {
    if(store.isDatingView) {
      page.value = store.cards.page
    }
    fetchData()
  },
  {
    flush: 'post',
    immediate: true
  }
)
</script>


<style lang="scss">
.cards {
  position: relative;
  width: 100%;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
  margin-bottom: 20px;

  @include mq('md') {
    grid-template-columns: repeat(3, 1fr);
  }

  .is-dating & {
    grid-template-columns: 1fr;
  }
}

.card {
  //position: absolute;
  position: relative;
  width: 100%;
  height: 100%;
  border-radius: 16px;
  //background-size: cover;
  //background-position: center;
  //box-shadow: 0 8px 16px rgba(0,0,0,0.2);
  //cursor: grab;
  transition: transform 0.3s ease, opacity 0.3s ease;
  user-select: none;

  .is-dating & {
    //width: unset;
    //height: 340px;
    //aspect-ratio: 9 / 16;
    margin: 0 auto;
  }

  &__photo {
    position: relative;
    //height: 100%;
    width: 100%;
    z-index: 1;
    aspect-ratio: 3 / 4;
    display: block;

    @include mq('md') {
      height: 340px;
      margin: 0 auto;
      width: auto;
    }

    img {
      object-fit: cover;
      height: 100%;
      width: 100%;
      border-radius: 6px;
    }
  }
  &__info {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 10;
    padding: 10px;
    font-weight: bold;
    color: #fff;
    //background: linear-gradient(to bottom, hsla(0, 0%, 100%, 0) 0, var(--background-box) 100%);
    background: linear-gradient(to bottom, rgba(0, 00, 0, 0) 0, #000000 100%);
    border-radius: 0 0 6px 6px;
  }
}

.card:last-child {
  cursor: grabbing;
}

.cards-swiper {
  display: flex;
  &__btn {
    display: flex;
    flex-grow: 1;
    justify-content: center;
    align-items: center;
    background: var(--background-primary);
    padding: 10px 15px;
    &:disabled {
      opacity: 0.3;
    }
    &.is-active {
      background: var(--background-secondary);
    }
    .i {
      font-size: 32px;
    }
  }
}
</style>

<template>
  <div class="subhead">
    <div class="subhead__tabs">
      <button 
        class="subhead__tab"
        :class="{ 'is-active' : $root.store.isDatingView }"
        @click="changeView(true)"
      >
        <Icon name="cards-blank" />
      </button>
      <button
        class="subhead__tab"
        :class="{ 'is-active' : !$root.store.isDatingView }"
        @click="changeView(false)"
      >
        <Icon name="users" />
      </button>
    </div>
  </div>
  <div class="cards">
    <div
      v-for="(item, index) in items"
      :key="item.id"
      class="card"
      @touchstart.passive="onTouchStart($event, index)"
      @touchend.passive="onTouchEnd($event, index)"
      @touchmove.passive="onTouchMove($event, index)"
      :style="{ transform: item?.transform }"
    >
        <router-link 
          class="card__photo"
          :to="{
            name: 'user',
            params: {
              user: item.id
            }
          }"
         >
          <img :src="item.photo" alt="" />
          <div class="card__info">
            <div class="card__title">{{ item.name }}, 26</div>
          </div>
        </router-link>

        <div class="cards-swiper" v-if="$root.store.isDatingView">
          <button 
            class="cards-swiper__btn"
            @click.preve="changePage(false)"
            :disabled="page === 1"
          >
            <Icon name="arrow-left" />
          </button>
          <button class="cards-swiper__btn" @click.preve="changePage(true)">
            <Icon name="arrow-right" />
          </button>
        </div>
      </div>
  </div>
  <button 
    v-if="items.length > 0 && items.length < total && !$root.store.isDatingView"
    @click.prevent="loadMore"
    class="btn btn--center"
  >
    Показать еще
  </button>
  
</template>